module.exports = __webpack_public_path__ + "static/media/flag-ka.a234f9ad.webp";